export default __webpack_public_path__ + "static/solarpanels-b22d04d49d1af3cb303f3b498bf35490.png";